// extracted by mini-css-extract-plugin
export default {"page--tokenExpired":"TokenExpiredPage_page--tokenExpired__nkORT"};